export function formatPhoneNumber(phoneNumberString) {
	if (!phoneNumberString) return '';
	const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    
    // Strict 10 digit limit for formatting
    const truncated = cleaned.slice(0, 10);

	const match = truncated.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
	if (match) {
        let formatted = '';
        if (match[1]) formatted += '(' + match[1];
        if (match[2]) formatted += ') ' + match[2];
        if (match[3]) formatted += '-' + match[3];
		return formatted;
	}
	return phoneNumberString;
}

// Helper for onChange events to enforce length and format
export function formatPhoneNumberInput(value) {
    if (!value) return value;
    // Prevent typing more than 14 chars "(123) 456-7890"
    if (value.length > 14) return value.substring(0, 14);
    return formatPhoneNumber(value);
}

export function removePhoneFormatting(phoneNumberString) {
	const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
	return cleaned;
}
